import React, { useEffect, useRef, useState } from "react";
import { FaArrowDown } from "react-icons/fa6";
import { useLocation, useParams } from "react-router-dom";
import { useContextChat } from "../../Context/ContextChat";
import { content } from "../../Context/translate";
import { language, useFETCH } from "../../Tools/APIs";
import MessageRecipient from "./MessageRecipient";
import Messages from "./Messages";
import MessageSender from "./MessageSender";
import NavChat from "./NavChat";

export const Chats = ({ id }) => {
  const [filter, setFilter] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const { newMessage, setNewMessage, chatDelelete, setMessageRead } =
    useContextChat();
  const distance = useRef(0);
  const disntanceInPercent = useRef(0);
  const [messages, setMessages] = useState([]);
  const { pathname } = useLocation();
  // const { id } = useParams();

  const scrollContainerRef = useRef(0);
  let scrollHeight = useRef(0);
  let scrollTop = useRef(0);

  let filterSelector = useRef(filter);
  // const { data, isLoading } = useFetch(
  //   `v1/chat/users/${id}/messages?page=${filterSelector.current}`
  // );

  let { data, isLoading, deleteItem, successfulDelete } = useFETCH(
    `v1/chat/users/${id}/messages?page=${filterSelector.current}`,
    `v1/chat/users/${id}/messages`,
    false,
    true,
    true,
    refresh,
    true
  );

  // useEffect(()=>{
  //     const interval = setInterval(() =>{
  //       filterSelctor = 1;
  //        setRefresh((prevRefresh)=> prevRefresh + 1);

  //        clearInterval(interval);
  //       }, 10000)

  // }, [refresh]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    distance.current = disntanceInPercent.current * windowHeight;
    scrollHeight.current = scrollContainerRef.current.scrollHeight;
    scrollTop.current = scrollContainerRef.current.scrollTop;

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth, windowHeight]);

  useEffect(() => {
    setMessages((prevMessages) => {
      if (data?.data?.data?.current_page > 1) {
        data?.data?.data?.data?.toReversed().map((value) => {
          prevMessages.push(value);
        });
        return prevMessages;
      } else {
        const prevMessagesCopy = [...prevMessages];
        const dataCopy = [...(data?.data?.data?.data || [])];
        let index = 0;
        let prevIndex = 0;
        while (
          prevIndex < prevMessagesCopy.length &&
          prevMessagesCopy[prevIndex].id == null
        ) {
          prevIndex++;
        }
        while (prevIndex < 100 && index < dataCopy.length) {
          if (prevMessagesCopy.length === prevIndex) {
            prevMessagesCopy.push(dataCopy[index]);
          } else {
            prevMessagesCopy[prevIndex] = dataCopy[index];
          }

          prevIndex++;
          index++;
        }

        return prevMessagesCopy;
      }
    });
    if (data?.data?.data?.current_page === 1) {
      const interval = setInterval(() => {
        filterSelector.current = 1;
        setRefresh((prevRefresh) => prevRefresh + 1);
        clearInterval(interval);
      }, 5000);
    }

    // });
  }, [data?.data?.data?.data]);

  useEffect(() => {
    setMessages([]);
    setMessageRead("");
    setFilter(1);
  }, [id, pathname]);

  useEffect(() => {
    if (chatDelelete === id) {
      setMessages([]);
      setFilter(1);
    }
  }, [chatDelelete]);

  function updateMessageByKey(key, updatedMessage) {
    setMessages((prevMessages) =>
      prevMessages.map((message) => {
        if (message.key === key) {
          return updatedMessage;
        }
        return message;
      })
    );
  }
  useEffect(() => {
  if (newMessage?.content && newMessage?.chatId === id) {
    if (newMessage.id) {
      updateMessageByKey(newMessage.key, newMessage);
      setNewMessage({});
    } else {
      setMessages((prevMessages) => [newMessage, ...prevMessages]);
    }
  }
  scrollHeight.current = scrollContainerRef.current.scrollHeight;
  scrollTop.current = scrollContainerRef.current.scrollTop;
}, [newMessage, id]);  // <== تأكد تضيف id في dependencies


  useEffect(() => {
    if (scrollHeight.current - (distance.current + scrollTop.current) < 1) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
    scrollHeight.current = scrollContainerRef.current.scrollHeight;
    scrollTop.current = scrollContainerRef.current.scrollTop;
  }, [messages]);

  useEffect(() => {
    distance.current = scrollContainerRef.current.scrollHeight;
    scrollHeight.current = scrollContainerRef.current.scrollHeight;
    scrollTop.current = scrollContainerRef.current.scrollTop;
    disntanceInPercent.current = distance.current / windowHeight;
  }, []);
  return (
    <div className="md:relative">
      <NavChat id={id} />
      <div
        onScroll={(e) => {
          if (data?.data?.data?.data?.length !== 0) {
            if (e.target.scrollTop === 0) {
              filterSelector.current = filter + 1;
              setFilter(filter + 1);
            }
          }
        }}
        ref={scrollContainerRef}
        className="pb-[12.5vh] max-md:pb-0 w-full flex-1 h-[80vh] space-y-1 chat overflow-y-scroll scroll-smooth max-md:px-5 md:px-16 bg-slate-200 py-3 text-black text-opacity-60 chat text-lg chat-background">
        {isLoading && (
          <div className="flex justify-center items-center">
            <h1 className="text-3xl font-bold">{content.Loading}</h1>
          </div>
        )}
        {renderMessages(messages, deleteItem, successfulDelete, isLoading, id)}
        {scrollHeight.current -
          (distance.current + scrollContainerRef.current.scrollTop) >
          100 && (
          <FaArrowDown
            color="white"
            onClick={() => {
              scrollContainerRef.current.scrollTop =
                scrollContainerRef.current.scrollHeight;
            }}
            size={40}
            className={`bg-Main p-2 rounded-full cursor-pointer bottom-[14%] fixed ${
              language === "ar"
                ? "right-[34%] max-md:right-2"
                : "left-[34%] max-md:left-2"
            } `}
          />
        )}
      </div>
      <Messages id={id} />
    </div>
  );
};

export default Chats;

const renderMessages = (
  messages,
  deleteItem,
  successfulDelete,
  isLoading,
  userId
) => {
  let currentDate = null;
  if (messages.length === 0 && !isLoading) {
    return (
      <div className="w-full h-full bg-slate-200 flex justify-center items-center text-xl font-bold  text-black text-opacity-60">
        {content.noMessages}
      </div>
    );
  }
  let index = 0;
  return messages?.toReversed().map((message) => {
    if (currentDate !== new Date(message.created_at).toLocaleDateString()) {
      currentDate = new Date(message.created_at).toLocaleDateString();
      return (
        <div key={message.id} className="pb-1">
          <div className="mx-auto px-2 py-1 my-2 bg-Secondary w-fit rounded-xl text-white font-semibold text-md">
            {currentDate}
          </div>
          {message.is_sent_by_auth_user ? (
            <MessageSender
              message={message}
              deleteMessage={() =>
                deleteItem(
                  message?.id,
                  `v1/chat/users/${userId}/messages/${message?.id}`
                )
              }
              successfulDelete={successfulDelete}
              index={index++}
            />
          ) : (
            <MessageRecipient message={message} />
          )}
        </div>
      );
    }
    return (
      <div key={message.id} className="pb-1">
        {message.is_sent_by_auth_user ? (
          <MessageSender
            message={message}
            deleteMessage={() =>
              deleteItem(
                message.id,
                `v1/chat/users/${userId}/messages/${message.id}`
              )
            }
            successfulDelete={successfulDelete}
            index={index++}
          />
        ) : (
          <MessageRecipient message={message} />
        )}
      </div>
    );
  });
};
